import React from 'react';

const ThankYou = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-4">Thank You for Participating</h1>
      <p>You may now return to Qualtrics to conclude the study.</p>
    </div>
  );
};

export default ThankYou;